<template>
  <div class="appplus">
    <van-nav-bar
      title=""
      left-arrow
      @click-left="$router.go(-1)"
      placeholder
      fixed
      safe-area-inset-top
    />

    <div class="appplus_top">
      <div>你好，</div>
      <div>欢迎报考广州市从化区教育局事业单位教师编制考试</div>
    </div>

    <div class="appplus_con">
      <div class="appplus_input" v-if="actionIndex == -1">
        <div class="appplus_input_left">
          <img
            src="https://inexweb.oss-cn-shenzhen.aliyuncs.com/uni/login/login_earth.png"
          />
          <div>中国(+86)</div>
        </div>
        <van-field
          style="flex: 1; padding: 0"
          placeholder="请输入手机号或用户名"
          placeholderStyle="line-height:100px;font-size:32px;"
          color="#222"
          fontSize="36px"
          v-model="form.username"
        ></van-field>
      </div>
      <div
        class="appplus_input"
        v-else
        @click="
          actionIndex = -1;
          form.password = '';
          form.code = '';
        "
      >
        <div class="appplus_input_left">
          <img
            src="https://inexweb.oss-cn-shenzhen.aliyuncs.com/uni/login/login_earth.png"
            mode="aspectFill"
          />
          <div>中国(+86)</div>
        </div>
        <div class="appplus_input_middle">
          {{ form.username }}
          <span style="font-size: 26rpx; padding-left: 10rpx">(修改)</span>
        </div>
      </div>

      <!-- 未注册 -->
      <template v-if="actionIndex == 0">
        <div class="appplus_input">
          <van-field
            placeholder="请输入验证码"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.code"
          >
            <template #button>
              <div
                class="appplus_input_btn"
                @click="readySendCode('login')"
                :style="{
                  opacity: num == 60 ? '' : '0.3',
                  background: '#3479f5',
                }"
              >
                {{ num == 60 ? "获取验证码" : `${num}秒` }}
              </div>
            </template>
          </van-field>
        </div>
        <div class="appplus_input">
          <van-field
            placeholder="请设置登录密码"
            type="password"
            :password="true"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.password"
          ></van-field>
        </div>

        <div class="appplus_input">
          <van-field
            placeholder="请设置真实姓名"
            :password="true"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.name"
          ></van-field>
        </div>

        <div class="appplus_input">
          <van-field
            placeholder="请设置身份证号"
            :password="true"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.card"
          ></van-field>
        </div>
      </template>
      <!-- 已注册有密码 -->
      <div class="appplus_input" v-else-if="actionIndex == 1">
        <van-field
          placeholder="请输入登录密码"
          type="password"
          :password="true"
          placeholderStyle="line-height:100px;font-size:32px;"
          color="#222"
          fontSize="36px"
          v-model="form.password"
        ></van-field>
      </div>
      <!-- 已注册无密码 -->
      <template v-else-if="actionIndex == 2">
        <div class="appplus_input">
          <van-field
            placeholder="请输入验证码"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.code"
          >
            <template #button>
              <div
                class="appplus_input_btn"
                @click="readySendCode('register')"
                :style="{
                  opacity: num == 60 ? '' : '0.3',
                  background: '#3479f5',
                }"
              >
                {{ num == 60 ? "获取验证码" : `${num}秒` }}
              </div>
            </template>
          </van-field>
        </div>
        <div class="appplus_input">
          <van-field
            placeholder="请设置登录密码"
            type="password"
            :password="true"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.password"
          ></van-field>
        </div>
      </template>
      <!-- 忘记密码 -->
      <template v-else-if="actionIndex == 3">
        <div class="appplus_input">
          <van-field
            placeholder="密码长度至少6位，且同时包含字母和数字"
            type="password"
            :password="true"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.password"
          ></van-field>
        </div>
        <div class="appplus_input">
          <van-field
            placeholder="请输入验证码"
            placeholderStyle="line-height:100px;font-size:32px;"
            color="#222"
            fontSize="36px"
            v-model="form.code"
          >
            <template #button>
              <div
                class="appplus_input_btn"
                @click="readySendCode('reset')"
                :style="{
                  opacity: num == 60 ? '' : '0.3',
                  background: '#3479f5',
                }"
              >
                {{ num == 60 ? "获取验证码" : `${num}秒` }}
              </div>
            </template>
          </van-field>
        </div>
      </template>

      <div class="appplus_tip" @click="changeActive(3)" v-if="actionIndex == 1">
        忘记密码？
      </div>
      <div
        class="appplus_btn1"
        :style="{ background: '#3479f5', opacity: loadingShow ? 0.5 : 1 }"
        @click="registerBtn"
        v-if="actionIndex == 0"
      >
        登录
      </div>
      <div
        class="appplus_btn1"
        :style="{ background: '#3479f5', opacity: loadingShow ? 0.5 : 1 }"
        @click="resetBtn"
        v-else-if="actionIndex == 3"
      >
        重置
      </div>
      <div
        class="appplus_btn1"
        :style="{ background: '#3479f5', opacity: loadingShow ? 0.5 : 1 }"
        @click="loginBtn"
        v-else-if="actionIndex > 0"
      >
        登录
      </div>
      <div
        class="appplus_btn1"
        :style="{ background: '#3479f5', opacity: isChecking ? 0.5 : 1 }"
        @click="checkUsername"
        v-else
      >
        {{ isChecking ? "检查中..." : "下一步" }}
      </div>
    </div>

    <div class="bottom">
      <div v-html="bottomTitle.content"></div>
    </div>
  </div>
</template>

<script>
import getCode from "@/common/createRsa.js";
export default {
  data() {
    return {
      isChecking: false,
      loadingShow: false,
      checked: [],
      // #ifdef APP-PLUS
      autoStatus: false,
      //  #endif
      // #ifndef APP-PLUS
      autoStatus: false,
      //  #endif
      univerifyStatus: false,
      form: {
        username: "",
        password: "",
        tshare: this.tshare || "",
        code: "",
        unicode: "",
      },
      actionIndex: -1, //1有密码 2短信验证 0未注册 3忘记密码
      num: 60,
      animation: "", // 动画样式
      animationTip: false,

      bottomTitle: {},
    };
  },
  props: {},
  created() {
    this.getContent(5472, "bottomTitle");
  },
  methods: {
    getContent(id, key) {
      this.$api.getUser.get_agreement({ id: id }).then((res) => {
        if (res.code == 200) {
          this[key] = res.result;
        } else {
          this.$toast.fail(res.result);
        }
      });
    },

    //重置密码
    resetBtn() {
      let rule = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      if (this.form.username == "") {
        this.$toast("手机号不能为空");
        return false;
      } else if (this.form.password == "") {
        this.$toast("密码不能为空");
        return false;
      } else if (!rule.test(this.form.password)) {
        this.$toast("密码至少六个字符，且同时包含字母和数字");
        return false;
      } else {
        if (this.loadingShow) {
          return;
        }
        this.loadingShow = true;
        let params = {};
        params.username = this.form.username;
        params.password = getCode(this.form.password);
        params.quhao = "+86".replace(/[^0-9]/gi, "");
        params.code = this.form.code || "";
        params.unicode = this.form.unicode || "";
        this.$api.getUser.usernameChangePassword(params).then((res) => {
          if (res.code == 200) {
            this.$toast("重置密码成功，请重新登录");
            this.actionIndex = -1;
            this.form.password = "";
            this.form.code = "";
          }
          this.loadingShow = false;
        });
      }
    },
    changeActive(active) {
      this.num = 60;
      this.form.password = "";
      this.form.code = "";
      this.actionIndex = active;
    },
    //手机号登录
    registerBtn() {
      console.log(8888);
      let rule = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W_]{6,}$/; //密码至少六个字符，且同时包含字母和数字，允许符号
      if (this.form.username == "") {
        this.$toast("手机号不能为空");
        return false;
      } else if (this.form.password == "") {
        this.$toast("密码不能为空");
        return false;
      } else if (!rule.test(this.form.password)) {
        this.$toast("密码至少六个字符，且同时包含字母和数字");
        return false;
      } else if (this.checkprotocol()) {
        if (this.loadingShow) {
          return;
        }
        this.loadingShow = true;

        let params = {};
        params.username = this.form.username;
        params.name = this.form.name || "";
        params.card = this.form.card || "";
        params.password = getCode(this.form.password);
        params.quhao = "+86".replace(/[^0-9]/gi, "");
        params.tshare = this.form.tshare || "";
        params.channel = this.channel || "";
        params.nickname = this.form.nickname || "";
        params.code = this.form.code || "";
        params.unicode = this.form.unicode || "";
        params.is_code = 1;
        this.$api.getDz.usernameRegister(params).then((res) => {
          if (res.code == 200) {
            this.$toast("登录成功");
            this.$store.commit("setUser", res.result);
            if (this.$store.state.redirect) {
              setTimeout(() => {
                this.$router.push(this.$store.state.redirect);
              }, 200);
            } else {
              this.$router.push({ path: "/home" });
            }
          }
          this.loadingShow = false;
        });
      }
    },
    loginBtn() {
      if (this.checkprotocol()) {
        if (this.loadingShow) {
          return;
        }
        this.loadingShow = true;
        let params = {};
        params.username = this.form.username;
        params.password = getCode(this.form.password);
        params.quhao = "+86".replace(/[^0-9]/gi, "");
        if (this.actionIndex == 2) {
          let rule = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
          if (!rule.test(this.form.password)) {
            this.$toast("密码至少六个字符，且同时包含字母和数字");
            return false;
          }
          params.code = this.form.code || "";
          params.unicode = this.form.unicode || "";
          params.is_code = 1;
        }
        this.$api.getUser.usernameLogin(params).then((res) => {
          if (res.code == 200) {
            this.$toast("登录成功");
            this.$store.commit("setUser", res.result);
            if (this.$store.state.redirect) {
              setTimeout(() => {
                this.$router.push(this.$store.state.redirect);
              }, 200);
            } else {
              this.$router.push({ path: "/home" });
            }
          }
          this.loadingShow = false;
        });
      }
    },
    getVerificationCode(status) {
      if (this.num != 60) {
        this.$toast("请勿重复发送验证码");
        return false;
      }
      if (!this.form.username) {
        this.$toast("手机号码不能为空");
        return false;
      }
      if (this.num == 60) {
        // this.$toast("即将发送验证码");
        this.$api.getDz
          .postUserCode({ tel: this.form.username })
          .then((res2) => {
            if (res2.code == 200) {
              this.form.unicode = res2.result;
              this.$toast("发送成功");
              var temar = setInterval(() => {
                if (this.num <= 0) {
                  clearInterval(temar);
                  this.num = 60;
                } else {
                  this.num--;
                }
              }, 1000);
            }
          });
      }
    },
    readySendCode(type) {
      this.getVerificationCode(type);
    },
    checkUsername() {
      if (this.checkprotocol()) {
        if (this.form.username == "") {
          this.$toast("请输入手机号或用户名");
          return false;
        }
        if (this.isChecking) {
          return;
        }
        this.isChecking = true;
        let params = {};
        params.username = this.form.username;
        this.$api.getUser.powerValidateUsername(params).then((res) => {
          if (res.code == 200) {
            //1有密码 2短信验证 0未注册
            this.actionIndex = res.result;
          }
          this.isChecking = false;
        });
      }
    },
    //验证协议
    checkprotocol() {
      return true;
      if (this.checked.length == 0) {
        // this.$toast('请先阅读并同意协议')
        this.animation = "shake";
        this.animationTip = true;
        setTimeout(() => {
          this.animation = "";
        }, 1500);
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less">
div {
  box-sizing: border-box;
}
.bottom {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0.62rem;
  text-align: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}

.appplus {
  width: 100%;
  text-align: left;
  .appplus_top {
    width: 100%;
    padding: 20px 40px;

    font-weight: 500;
    font-size: 18px;
  }
  .appplus_con {
    width: 100%;
    .appplus_input {
      height: 50px;
      width: 320px;
      margin: 10px auto;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f4f4f4;
      .appplus_input_left {
        width: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        font-size: 14px;
        > img {
          width: 20px;
          height: 20px;
        }
        > span {
          font-size: 14px;
        }
      }

      .appplus_input_middle {
        flex: 1;
        font-size: 14px;
      }

      .appplus_input_btn {
        text-align: center;
        // width: 100px;
        font-size: 11px;
        color: #fff;
        border-radius: 3px;
        padding: 1px 10px;
      }
    }

    .appplus_btn1 {
      width: 300px;
      margin: 30px auto;

      font-size: 14px;
      font-weight: 500;
      display: flex;

      justify-content: center;
      align-items: center;

      border-radius: 25px;
      padding: 12px 0;
      color: #fff;
    }

    .appplus_tip {
      width: 300px;
      margin: 0 auto;
      display: flex;

      justify-content: flex-end;
      align-items: center;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
